import { Film, Tv } from 'lucide-react';
import { useMediaType } from '../contexts/MediaTypeContext';

export function MediaToggle() {
  const { mediaType, setMediaType } = useMediaType();

  return (
    <div className="flex items-center bg-slate-700/50 rounded-full p-1">
      <button
        onClick={() => setMediaType('movie')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
          mediaType === 'movie'
            ? 'bg-gradient-to-r from-cyan-500 to-teal-500 text-white shadow-lg'
            : 'text-slate-400 hover:text-white'
        }`}
      >
        <Film size={16} />
        <span>Movies</span>
      </button>
      <button
        onClick={() => setMediaType('tv')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
          mediaType === 'tv'
            ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
            : 'text-slate-400 hover:text-white'
        }`}
      >
        <Tv size={16} />
        <span>TV Shows</span>
      </button>
    </div>
  );
}
